import React, { useEffect } from 'react';
import { Row, Col } from 'antd'; // Assuming you're using Ant Design
import styles from './styles.module.css';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import DOMPurify from "isomorphic-dompurify";

import { fetchwebsiteBlogByLink } from '../../store/blogsSlice';
import Content from './Content';


function BlogDetailsPage() {

    const link = useParams();
    console.log("useParams*****", link);
    const dispatch = useDispatch();
    const selectedBlog = useSelector((state) => state.blogsReducer.selectedBlog)
    console.log("selectedBlog*****", selectedBlog);


    useEffect(() => {
        dispatch(fetchwebsiteBlogByLink(link.link))


    }, [dispatch, link.link])




    // const blog = {
    //     id: 1,
    //     title: 'The Ultimate Guide to React',
    //     // author: 'John Doe',
    //     // date: 'November 13, 2024',
    //     imageUrl: 'https://www.mindadmission.com/wp-content/uploads/2022/06/3-Tech-Trends.jpg', 
    //     content: `

    //         React is a popular JavaScript library for building user interfaces. 
    //         It allows developers to create large web applications that can change data, 
    //         without reloading the page. Its main goal is to be fast, scalable, and simple. 
    //         In this guide, we will cover everything from basics to advanced topics in React.
    //     `,
    // };

    return (
        <div className={`container ${styles.blogDetailsContainer}`} style={{ padding: '40px 20px' }}>
            <div className='blogrow' >

                <Row justify="center">
                    <Col xs={24} sm={20} md={16} lg={14}>
                        <div className={styles.blogHeader}>
                            <h1 className={styles.title}>{selectedBlog?.title}</h1>
                            {/* <p className={styles.meta}>
                            By {blog.author} | {blog.date}
                        </p> */}
                        </div>

                        <div className={styles.imageContainer}>
                            <img src={`${process.env.REACT_APP_BACKEND_URL}/${selectedBlog?.image || ''}`} alt={selectedBlog.title} className={styles.blogImage} />
                        </div>

                        {/* <div className={styles.content}>
                            <p>{selectedBlog.description}</p>
                        </div> */}

                        <div className={styles.blogtext}>
                            <Content
                                HTML={DOMPurify.sanitize(selectedBlog?.description)}
                            />
                        </div>
                    </Col>
                </Row>
            </div>

        </div>
    );
}

export default BlogDetailsPage;
